// extracted by mini-css-extract-plugin
module.exports = {"container":"ImAuftrag_container__1mrXK","logocontainer":"ImAuftrag_logocontainer__ZavlN"};